import { render } from "./StoreReviews.vue?vue&type=template&id=4fa27720&scoped=true&bindings={}"
import script from "./StoreReviews.vue?vue&type=script&lang=js"
export * from "./StoreReviews.vue?vue&type=script&lang=js"

import "./StoreReviews.vue?vue&type=style&index=0&id=4fa27720&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fa27720"

export default script